import { NAVIGATE_PATH } from '../constants';

const useAuthExternalUser = () => {
  const externalUserLogout = async () => {
    sessionStorage.clear();
    window.location.replace(process.env.REACT_APP_EXTERNAL_USER_LOGOUT_URL);
  };

  const externalUserDetails = () => {
    const externalUserData = JSON.parse(
      sessionStorage.getItem('externalUserData')
    );
    return externalUserData;
  };

  const getUserType = () => {
    const userType = sessionStorage.getItem('userType')
    return userType;
  }

  return {
    externalUserLogout,
    externalUserDetails,
    getUserType
  };
};

export default useAuthExternalUser;
